const formatters : Record<string, Intl.DateTimeFormat> = {};

export function standardFormatDate(date: Date | null | undefined, timeZone?: string) : string | null  {
    if (date == null)
        return null;

    const formatterId = timeZone ?? "__DEFAULT__";
    let formatter = formatters[formatterId];

    if (formatter == null) {
        formatter = Intl.DateTimeFormat(window.navigator.languages,
            {
                day: '2-digit', month: '2-digit', year: 'numeric',
                hour: '2-digit', minute: '2-digit', second: '2-digit',
                timeZone: timeZone
            });
        formatters[formatterId] = formatter;
    }

    return formatter.format(date);
}

export function toISODatetimeString(date: Date): string | null {
    if (date == null)
        return null;
    return new Date(date).toLocaleString();
}